/**
 * The single source of truth for the polygon-vs-circle threshold used by
 * county search. Mirrors the same constant on the API (see
 * `App\Services\Geo\SearchAreaResolver::POLYGON_TO_CIRCLE_THRESHOLD_MILES`).
 *
 * At or below this radius the search constrains gardens to a buffered
 * county polygon. Above it the search switches to a circle anchored on the
 * county centroid; buffering the polygon at large radii produces too many
 * vertices to ship in a URL.
 */
export const POLYGON_TO_CIRCLE_THRESHOLD_MILES = 5

/**
 * Classify a radius into the search-area mode the API will pick.
 *
 *   <= 0          -> 'none'    (no expansion; filter by the base polygon)
 *   0 < r <= 5    -> 'polygon' (filter by a buffered ring)
 *   r > 5         -> 'circle'  (filter by a centroid-anchored circle)
 *
 * Non-finite or missing input is treated as 'none'.
 *
 * @param {number|null|undefined} miles
 * @returns {'none'|'polygon'|'circle'}
 */
export function modeForRadius(miles) {
  const value = Number(miles)
  if (!Number.isFinite(value) || value <= 0) return 'none'
  if (value <= POLYGON_TO_CIRCLE_THRESHOLD_MILES) return 'polygon'
  return 'circle'
}
